import { render, staticRenderFns } from "./dict.vue?vue&type=template&id=4bb101f8&scoped=true"
import script from "./dict.vue?vue&type=script&lang=js"
export * from "./dict.vue?vue&type=script&lang=js"
import style0 from "./dict.vue?vue&type=style&index=0&id=4bb101f8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bb101f8",
  null
  
)

export default component.exports